import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthenticationService, SplashScreenService } from '@core/services';
import { catchError, finalize, map, of } from 'rxjs';

export const authGuard: CanActivateFn = (route, state) => {
	const router = inject(Router);
	const authService = inject(AuthenticationService);
	const splashScreenService = inject(SplashScreenService);

	if (authService.isAuthenticated()) {
		return true;
	}

	if (authService.getRefreshToken()) {
		splashScreenService.show();
		return authService.refreshAccessToken().pipe(
			map((token) => {
				if (token) {
					return true;
				}
				authService.clearTokens();
				return router.createUrlTree(['/auth/login'], {
					queryParams: { returnUrl: state.url },
				});
			}),
			catchError(() => {
				authService.clearTokens();
				return of(
					router.createUrlTree(['/auth/login'], {
						queryParams: { returnUrl: state.url },
					})
				);
			}),
			finalize(() => splashScreenService.hide())
		);
	}

	authService.clearTokens();
	return router.createUrlTree(['/auth/login'], {
		queryParams: { returnUrl: state.url },
	});
};
